import React from 'react';
import './loader.css';

const Loader =()=> {
    
        return (
                <div className='progressbar'></div>
        )
    
}
export default Loader;